import {
  RECEIVE_DATA,
  RECEIVE_SBS_DATA,
  REQUEST_DATA,
  REQUEST_SBS_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  data: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  sbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  fetchingSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.data = defaultState.data;
      state.sbsData = defaultState.sbsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_DATA: {
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    case REQUEST_SBS_DATA: {
      state.fetchingSbsData[action.summary] = true;
      state.sbsData[action.summary] = defaultState.sbsData[action.summary];
      break;
    }
    case RECEIVE_SBS_DATA: {
      state.fetchingSbsData[action.summary] = false;
      state.sbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
export default reducer;
